import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const ctaFooter: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/cta-footer`),
};

export default ctaFooter;
